export const IncomFreqency=[
	{text:'Yearly',value:1},
	{text:'Monthly',value:12},
	{text:'Twice Per Month',value:24},
	{text:'Weekly',value:52},
	{text:'Every Two Weeks',value:26}
]
export const personType={'adult':'Adult','student':'Student','child':'Child'}
export const childIncomeTypeList=[
	'Military-Currently Deployed',
	'Military-Currently Not Deployed',
	'Earnings from Work',
	'Public Assistance/Child Support/Alimony',
	'Unemployment/Veterans/Strike Benefits',
	'Workers Compensation/Social Security Disability Insurance(SSDI)',
	'Pensions/Black Lung Benefits/Retirement',
	'Cash Payments/Rental Income/Earned Intrest',
	'Investment Income/Annuities/All Other Income'
]
export const IncomType=[
	'Military-Currently Deployed',
	'Military-Currently Not Deployed',
	'Earnings from Work',
	'Public Assistance/Child Support/Alimony',
	'Unemployment/Veterans/Strike Benefits',
	'Workers Compensation/Social Security Disability Insurance(SSDI)',
	'Pensions/Black Lung Benefits/Retirement',
	'Cash Payments/Rental Income/Earned Intrest',
	'Investment Income/Annuities/All Other Income'
]
export const incomeModal={
	"source": "",
	"amount": 0.00,
	"frequency": ""
}
export const declinedReasonList = [
	{
		"id" : 1,
    	"name" : "Income over the allowable amount",
    	"isApplicable" : false
  },
  {
    "id" : 2,
    "name" : "SNAP/TANF/FDPIR case # invalid",
    "isApplicable" : false
  },
  {
    "id" : 3,
    "name" : "Incomplete application.  The following is missing",
    "description" : "",
    "isApplicable" : false
  },
  {
    "id" : 3,
    "name" : "Other:",
    "description" : "",
    "isApplicable" : false
  }
]
export const personModal={
	"fname": "",
	"lname": "",
	"mname": "",
	"grade": '',
	"personType": "",
	"liveUnderFosterCare": false,
	"runaway": null,
	"homelessOrMigrantOrRunawayOptions":[],
	"mcKinneyVentoHomeless": null,
	"migrantEducationPrg": null,
	"headStart": null,
	"filledTheApplication": false,
	"income": [
		//Object.assign({},incomeModal)
	],
	"noIncome": null,
	"TotalIncome": 0.00,
	"ethenticity": null,
	"race": [],
	"isFreeMeal": false,
	"studentRecId": 0,
	"id":0,
	isSelected:false
}

export const lunchBreakfastModal={
	"id": 0,
	"Date": "",
	"status": "pending",
	"mealSchoolId": 0,
	"approveDeclineDt": null,
	"persons": [
		{
			"fname": "",
			"lname": "",
			"mname": "",
			"grade": '',
			"personType": personType.adult,
			"liveUnderFosterCare": false,
			"runaway": null,
			"migrantEducationPrg": null,
			"mcKinneyVentoHomeless": null,
			"headStart": null,
			"homelessOrMigrantOrRunawayOptions":[],
			"filledTheApplication": true,
			"income": [
				//Object.assign({},incomeModal)
			],
			"noIncome": false,
			"TotalIncome": 0.00,
			"ethenticity": null,
			"race": [],
			"isFreeMeal": false,
			"studentRecId": 0,
			"id":0,
			"contact":{
				"phone": "",
				"email": sessionStorage.getItem('loggedInUserInfo'),
				"street1": "",
				"street2": "",
				"city": "",
				"state": "",
				"zip": "",
			},
			"ssn": "",
			"noSSN": false,
		}
	],
	"assistancePrograms": [
	  {
		"isApplicable": false,
		"id": "1",
		"name": "Supplemental Nutrition Assistance Program (SNAP)",
		"accronym": "SNAP",
		"caseNumber": ""
	  },
	  {
		"isApplicable": false,
		"id": "2",
		"name": "Temporary Assistance for Needy Families (TANF)",
		"accronym": "TANF",
		"caseNumber": ""
	  },
	  {
		"isApplicable": false,
		"id": "3",
		"name": "Food Distribution Program on Indian Reservations (FDPIR)",
		"accronym": "FDPIR",
		"caseNumber": ""
	  }
	],	
	"SSN": "",
	"noSSN": null,
	isAllFoster:null,
	isIncomeAfter:null
}
export const MealBenefitEligibilityPrograms=[
	{id:1,text:'SNAP/TANF/FDPIR',value:['SNAP','TANF','FDPIR']},
	{id:2,text:'Foster/Homeless/Migrant/Runaway/Head Start',value:['Foster','Homeless','Migrant','Runaway','HeadStart']},
	{id:3,text:'Federal Income Based',value:['FederalIncome']},
	{id:4, text:'State Income Based',value:['StateIncome']}
];


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal.js